<template>
  <section class="new-team-bios">
    <div class="container">
      <div class="bios_container">
        <ul class="bios_list">
          <template v-for="(value, key) in shopifyData.membersInfo" :key="key">
            <li class="bios_list-item">
              <h4 class="bios_heading">
                <span v-html="sanitizeHtml(value.name)" />
                <span v-html="sanitizeHtml(value.title)" />
              </h4>
              <p class="bios_text" v-html="sanitizeHtml(value.info)" />
            </li>
          </template>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>
<style scoped>
.container {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.bios_container {
  width: 100%;
  padding: 110px 0 0px;
}

.bios_list {
  display: flex;
  flex-direction: column;
  gap: 110px;
  padding-bottom: 110px;
}

.bios_list-item {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.only-mob {
  display: none;
}

.bios_heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #000000;
}

.bios_heading span {
  display: block;
}

.bios_text {
  font-family: 'Adobe Caslon Pro', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  letter-spacing: 0.02em;
}

.bios_text a {
  text-decoration: underline;
}

@media screen and (max-width: 767px) {
  .bios_container {
    padding: 40px 0 0px;
  }

  .bios_list {
    gap: 40px;
    padding-bottom: 40px;
  }

  .bios_text {
    font-size: 14px;
  }

  .only-mob {
    display: flex;
  }

  .bios_list-item {
    gap: 10px;
  }
}
</style>
